export default __webpack_public_path__ + "static/media/ILUSTRACIONES_11.2aefe4ee.png";